import React, { useState } from "react";
import moment from "moment";
import {
  Col,
  Row,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import { SERVER_DATE_FORMAT } from "./TakeABreak";
import { useLocation, useNavigate } from "react-router-dom";

import { extendPause } from "../../../QueryFunctions/queryfunction";
import { useRequestProcessor } from "../../../requestProcessor";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { StyledButton, StyledCardHeader } from "./styles";
import { useAtom } from "jotai";
import { mobileAtom } from "../../../AtomStore/store";
export const DEFAULT_FORMAT = "MMM DD, YYYY";

const ExtendPause = () => {
  const location = useLocation();
  const item = location.state;
  const [state, setState] = useState({});
  const navigate = useNavigate();

  const { useMutationWrapper } = useRequestProcessor();

  const ExtendPause = useMutationWrapper("Resume", () =>
    extendPause(item.request_id, state.endDate, navigate)
  );
  const validate = () => {
    if (state.endDate === undefined) {
      setState({ ...state, error: "Please Select End Date" });
      return false;
    } else {
      return true;
    }
  };

  const submit = (e) => {
    e.preventDefault();
    if (validate()) {
      ExtendPause.mutate();
    } else {
    }
  };
  if (item) {
    return (
      <div className="m-[10px] mt-[20px]">
        {ExtendPause?.isLoading && <SpinnerLoading />}

        <div className="bg-white rounded-lg shadow-md p-2">
          <form className="md:p-4 space-y-4 pb-4">
            <div className="grid  grid-cols-2 gap-4">
              {/* Current End Time */}
              <div className="border-r md:pr-4">
                <label className="block text-sm font-medium text-black mb-2">
                  Current End Time
                </label>
                <div className="flex items-center">
                  <FootprintDatePicker
                    defaultDate={moment(item?.end_date).format(DEFAULT_FORMAT)}
                    inputProps={{ disabled: true }}
                    disabled={true}
                  />
                </div>
              </div>

              {/* New End Date */}
              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  New End Date
                </label>
                <div className="flex items-center right-align">
                  <FootprintDatePicker
                    onChange={(date) => {
                      setState({
                        ...state,
                        endDate: date,
                        error: undefined,
                      });
                    }}
                    inputProps={{
                      placeholder: "Select date",
                    }}
                    timeFormat={false}
                    minimumDate={moment(item?.end_date, SERVER_DATE_FORMAT).add(
                      "days",
                      1
                    )}
                    maximumDate={moment(item?.date, SERVER_DATE_FORMAT).add(
                      89,
                      "days"
                    )}
                  />
                </div>
              </div>
            </div>

            {/* Error Message */}
            {state.error && (
              <div className="text-red-500 text-sm">{state.error}</div>
            )}

            {/* Submit Button */}
            <div className="text-center">
              <StyledButton onClick={(e) => submit(e)}>Submit</StyledButton>
            </div>
          </form>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <p>Extended Pause</p>
      </div>
    );
  }
};

export default ExtendPause;
